import React from "react";
import "./Logo.css";

const Logo = () => {
  return (
    <div className="logo">
      <span className="logo-text">ШАХРИЗАДА</span>
    </div>
  );
};

export default Logo;
